/**
 * Maps the `code` of a rejected upload (response.data.rejected[] from
 * /api/fileupload) to an i18n key + English default for the user message.
 * Codes come from backend/lib/gpx-validate.js.
 */

const GPX_REJECTION_TEXT = {
    gpxTooLarge: { id: 'uploads.gpx-too-large', text: 'the file is too large' },
    gpxNotParseable: { id: 'uploads.gpx-not-parseable', text: 'the file could not be read as GPX' },
    gpxNoTrackpoints: { id: 'uploads.gpx-no-trackpoints', text: 'no trackpoints were found in the file' },
    gpxTooFewPoints: { id: 'uploads.gpx-too-few-points', text: 'the track has too few points' },
    gpxZeroDistance: { id: 'uploads.gpx-zero-distance', text: 'the track has no length' },
    gpxInvalidCoordinates: { id: 'uploads.gpx-invalid-coordinates', text: 'the file contains invalid coordinates' },
};

const GENERIC = { id: 'uploads.gpx-rejected-generic', text: 'the file could not be used' };

export const GPX_REJECTION_CODES = Object.keys(GPX_REJECTION_TEXT);

export function gpxRejectionReason(code) {
    return GPX_REJECTION_TEXT[code] || GENERIC;
}
